<template>
    <div>
        <section class="l-section l-section--hero l-section--tall">
            <span class="o-shape-rect | bg-pink | --t20 --l0 --rot110 | u-dn@sm-max" v-parallax="{ x: .2, y: -.3 }"></span>
            <img src="~assets/img/layout/deco/egg.png" alt="Decoration" class="o-deco | u-img | --t40 --l5 --w15 u-dn@sm-max" v-parallax=".3">

            <span class="o-shape-rect | bg-blue | --b80 --l50 --rot140 | u-dn@sm-max" v-parallax=".2"></span>
            <img src="~assets/img/layout/deco/fish.png" alt="Decoration" class="o-deco | u-img | --t-25 --r20 --w30 u-dn@sm-max" v-parallax="-.2">

            <img src="~assets/img/layout/deco/peach.png" alt="Decoration" class="o-deco | u-img | --b0 --r-5 --w15 u-dn@sm-max" v-parallax="{ x: -.6, y: .6 } ">
            <span class="o-shape-circle | bg-orange text-t3 | --b80 --l90 | u-dn@sm-max" v-parallax="{ x: .3, y: 1 }"></span>

            <div class="l-grid">
                <span class="l-section__line"></span>
                <div class="l-grid__row --justify-center | text-center">
                    <div class="w-full sm:w-3/4 md:w-2/3 lg:w-3/4">
                        <h1 class="l-section__title | t-t1-serif">{{ page.content.header_title }}</h1>
                        <markdown
                            :content="page.content.header_subtitle"
                            class="w-full xs:w-3/4 md:w-2/3 lg:w-3/4 | m-auto | t-cms"
                        ></markdown>
                    </div>
                </div>
            </div>
        </section>

        <section class="l-section">
            <div class="l-grid">
                <div class="l-grid__row --justify-center@md-max">

                    <div class="w-full sm:w-3/4 md:w-1/2">
                        <h1 class="l-section__title | t-t1 | text-center md:text-left">{{ page.content.values_title }}</h1>

                        <div
                            v-if="page.content.values_image[0]"
                            class="o-composition-container--rounded"
                        >
                            <img
                                :src="page.content.values_image[0].filename|resources('images')"
                                alt=""
                                class="u-img"
                            >
                            <img src="~assets/img/layout/deco/apple.png" alt="Decoration" class="p-values__deco o-deco | u-img |--l5 --b-10@md --w15" v-parallax="-.6">
                        </div>

                    </div>

                    <div class="w-full xs:w-5/6 sm:w-3/4 md:w-1/2">
                        <ul class="o-icon-list o-icon-list--big">
                            <li
                                v-for="(item, key) in page.content.values"
                                :key="key"
                                class="o-icon-list__item"
                            >

                                <span class="o-icon-list__icon">
                                    <asset
                                        v-if="item.icon[0]"
                                        :src="item.icon[0].filename|resources('illustrations')"
                                    ></asset>
                                </span>
                                <span class="o-icon-list__content">

                                    <h3
                                        v-if="item.label"
                                        class="t-xs uppercase | mb-1"
                                    >
                                        {{ item.label }}
                                    </h3>
                                    <h4
                                        v-if="item.tagline"
                                        class="t-t3 | mb-2"
                                    >
                                        {{ item.tagline }}
                                    </h4>
                                    <markdown
                                        tag="span"
                                        :content="item.description"
                                        class="t-s"
                                    ></markdown>

                                </span>

                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section class="l-section l-section--tall">
            <span class="o-shape-rect | bg-yellow | --t0 --r95 --rot135 | u-dn@sm-max" v-parallax=".2"></span>
            <img src="~assets/img/layout/deco/sloe.png" alt="Decoration" class="o-deco | u-img | --t30 --l10 --w15 u-dn@sm-max" v-parallax="{ x: -.2, y: .8 }">
            <img src="~assets/img/layout/deco/rain.png" alt="Decoration" class="o-deco | u-img | --t40 --l-5 --w20 u-dn@sm-max" v-parallax="-.6">

            <span class="o-shape-circle | bg-pink | --l90 --t40 | u-dn@sm-max" v-parallax=".4"></span>
            <img src="~assets/img/layout/deco/sparkle.png" alt="Decoration" class="o-deco | u-img | --t20 --r0 --w15 u-dn@sm-max" v-parallax=".2">
            <div class="l-grid">
                <div class="l-grid__row --justify-center | text-center">
                    <div class="w-full sm:w-3/4 md:w-1/2">
                        <h1 class="l-section__title | t-t1-serif">{{ page.content.ingredients_title }}</h1>
                        <markdown
                            :content="page.content.ingredients_content"
                            class="t-cms"
                        ></markdown>
                    </div>
                </div>
            </div>
        </section>

        <Gallery />
    </div>
</template>

<script>/* eslint-disable */

import Asset from 'components/Asset'
import Btn from 'components/Btn'
import Gallery from 'components/Instagram'
import Markdown from 'components/Markdown'

import Meta from 'mixins/meta'

export default {
    name: 'Mission',
    components: {
        Asset,
        Btn,
        Gallery,
        Markdown
    },
    props: {
        page: Object,
        site: Object
    },
    mixins: [ Meta ]
}

</script>

<style>
</style>
